module.exports = __webpack_public_path__ + "static/media/21.4c557864.png";